{
  "main": {
    "welcome": "Салом {company}!",
    "new_messages": "moshina yo'q | {n} moshin | {n} moshina",
    "appeal": "Murojaat yozing",
    "appeal_content": "Айтадиган нарсангиз борми? Бизнинг Telegram бот оркали йангилик яратинг!",
    "full_lang": {
      "en": "English",
      "ru": "Русский",
      "uz": "O'zbekcha",
      "uz-to": "Ўзбекча"
    },
    "short_lang": {
      "en": "En",
      "ru": "Ру",
      "uz": "O'z",
      "uz-to": "Ўз"
    },
    "live_stream": "Жонли эфир",
    "sum": "сум",
    "sections": "рубрикалар",
    "all": "Ҳаммаси",
    "main": "асосий",
    "categories": "Категориялар",
    "contacts": "Контактлар",
    "information": "Ма'лумот",
    "more": "Батафсил",
    "return": "Қайтиш",
    "read_also": "Шунингдек укинг"
  },
  "footer": {
    "disclaimer_text": "Сайтдаги янгиликлардан фойдаланиш учун ёзма розилик талаб етилади",
    "founder": "Асосчиси",
    "certificate": "Шаҳодатнома",
    "date_issued": "Берилган сана"
  },
  "not-found": {
    "not-found": "бундай сахифа мавжуд эмас ёки учирилган"
  },
  "search_bar": {
    "input_placeholder": "Qidirmoq",
    "result": "So'rov bo'yicha natijalar",
    "result_not_first": "Talab bo'yicha",
    "result_not": "hech narsa topilmadi",
    "sort_new": "Birinchisi yangi",
    "sort_old": "Avval eski",
    "recomend": "Siz uchun tavsiyalar:"
  },
  "months": {
    "january": "Январ",
    "february": "Феврал",
    "march": "Март",
    "april": "Апрел",
    "may": "Май",
    "june": "Июн",
    "july": "Июл",
    "august": "Август",
    "september": "Сентябр",
    "october": "Октябр",
    "november": "Ноябр",
    "december": "Декабр"
  },
  "days": {
    "today": "Бугун",
    "yesterday": "Кеча",
    "0": "Якшанба",
    "1": "Душанба",
    "2": "Сешанба",
    "3": "Чоршанба",
    "4": "Пайшанба",
    "5": "Жума",
    "6": "Шанба"
  },
  "video_player": {
    "volume": "Tovush",
    "start_pauza": "Boshlash/pauza",
    "mini_screen": "Mini-pleer",
    "full_screen": "Keng ekran",
    "back": "Qaytish"
  },
  "error": {
    "error": "Ҳато",
    "search": "Сизни қизиқтирган янгиликларни топиш учун қидирувдан фойдаланишингиз мумкин",
    "orback": "ёки олдинги сахифага қайтинг",
    "input": "Қидириш...",
    "nothing-found": "Хеч нарса топилмади"
  },
  "sayt_test": {
    "saytTest": "Сайт синов режимда ишлаяпти"
  },
  "routes": {
    "LiveStream": "Жонли эфир",
    "404": "Топилмади",
    "Search": "Қидирув",
    "SearchQuery": "Қидирув {query}",
    "NewsDetail": "Zamon янгиликлар",
    "FeedWrapper": "Zamon янгиликлар",
    "MainWrapper": "{category} Zamon янгиликлар",
    "StaffDetail": "Персонал кабинет",
    "AccountSettings": "Аккаунт узгартириш",
    "CreateArticles": "Янги сахифа яратиш",
    "EditArticle": "Сахифани узгартириш",
    "PreferredLang": "Янгилик яратиш",
    "Articles": "Янгиликлар",
    "StaffPage": "Замон жамоаси",
    "LogIn": "Кириш",
    "Registration": "Регистрация",
    "Recovery": "Парол тиклаш"
  },
  "authorization": {
    "enter": "Кириш",
    "registration": "Ройхатдан Отиш",
    "login": "Логин",
    "password": "Парол",
    "wronglogin": "* Нотогри логин",
    "wrongpassword": "* Нотогри пароль",
    "forogtPassword": "Пароль унутдингизми?",
    "mainPage": "Асосий сахифага кайтиш",
    "name": "Исм",
    "surname": "Фамилия",
    "phone": "Телефон номер",
    "email": "электрон почта",
    "continue": "Давом эттириш",
    "realName": "Хакикий исмингизни йозинг",
    "realsurname": "хакикий фамилиянгизни йозинг",
    "enterPhone": "телефон номер киритинг",
    "entermail": "електрон почтенгизни киритинг",
    "emptyArea": "*Ушбу катор толдирилиши шарт ",
    "newPassword": "Парол ойлаб топинг",
    "createNewPassword": "Йанги парол билан келинг",
    "replyNewPassword": "Паролни кайта киритинг",
    "back": "Оркага",
    "needLogin": "Кириш учун сизга логин керак болади",
    "passwordLength": "Парол камида  олтита ракам, харф ва тиниш белгилардан иборат болиши керак",
    "showPassword": "* Парол жуда киска",
    "passwordMismatch": "*Пароллар мос келмаябди",
    "busyLogin": "*Логин «Onegin» банд",
    "infPassport": "Пасспорт расмини кошинг",
    "contentPassport": "* Расм сифатли болиши керак, паспортда порлок ва сойасиз, йахши окилган малумотлар болиши керак",
    "completeRegister": "Ройхатдан отиш тугалланди",
    "getImage": "Расмни тортинг",
    "selectImage": "Танлаш...",
    "imageFormat": "JPG, PNG",
    "image": "Расм",
    "message": "Текширувдан отгандан сонг, биз сизнинг электрон почтангизга шахсий хисобингизни кириш учун хавола юборамиз",
    "validation": "Тасдиклаш 1 дан 3 иш кунигача давом этади",
    "clear": "Тушунарли",
    "resetPassword": "Паролни тиклаш",
    "passwordRecovery": "Паролни тиклаш",
    "mailMessage": "Куйида електрон почта манзилингизни киритинг ва биз сизга янги паролни йаратиш бойича корсатмаларни оз ичига олган електрон почта хабарни юборамиз",
    "yourMail": "Сизнинг электрон манзилингиз",
    "resetEmail": "*Ройхатдан отиш учун пайтида корсатилган електрон почта манзилини киритинг",
    "instruction": "Сизнинг почтангизга йанги паролни йаратиш бойича корсатмалар йуборилган електрон почта йуборилди",
    "saveChanges": "Озгаришлар сакланди",
    "verifyTitle": "Тасдиклаш коди ройхатдан отиш пайтида сиз корсатган ракамга  СМС оркали юборилади",
    "verification_code_invalid": "Ноту'г'ри тасдиклаш коди",
    "confirmCode": "Тасдиклаш коди",
    "repeatCode": "Кодни кайта юбориш",
    "confirmCodeBtn": "Кодни тасдиклаш",
    "humanPassportTitle": "Расмда корсатилгандек очик  пасспортли расм кошинг →",
    "explanation": "*Сурат сифатли болиши керак. Куйош козойнакли  фотосуратга рухсат берилмайди, йуз йахши йоритилган болиши керак",
    "overlay": "Толик ройхатга олиш"
  },
  "world": {
    "world_population": "Дунё ахолиси"
  },
  "staff_page": {
    "count_news": "Ҳабарлар",
    "count_views": "Кўринишлар",
    "about_me": "Ўзлари ҳақида",
    "last_news": "Охирги мақола:",
    "journalists": "Журналистлар",
    "employees": "Ходимлар",
    "news_card": {
      "title": "В Ташкенте прошёл ежегодный фестиваль электронной музыки",
      "data": "08.05.2021, 22:57",
      "category": "Подкатегория"
    }
  },
  "header": {
    "new_news": "Янгилик яратиш",
    "auth": "Авторизация",
    "appeal": "Аппелйатсия йозинг"
  },
  "news__detail": {
    "share": "share link",
    "share_facebook": "share on facebook",
    "share_instagram": "share on instagram",
    "share_telegram": "share on telegram",
    "share_title": "Share:",
    "tags_title": "Tags:"
  },
  "sport": {
    "math_started": "Матч бошланди"
  },
  "time": {
    "hour_ago": "соат",
    "minute_ago": "дақиқа",
    "ago": "олдин"
  },
  "uzbekistan": {
    "selectCountry": "Сонгги йангиликларни кориш учун минтакани танланг:",
    "close": "  Йопиш",
    "karakalpakistan": "Коркалпогистон Республикаси",
    "khorezm": "Хоразим виоляти",
    "navoi": "Навоий вилояти",
    "bukhara": "Бухоро вилояти",
    "samarkand": "Самарканд вилояти",
    "karshi": "Кашкадаря вилояти",
    "jizzax": "Жиззах вилояти",
    "surkhandarya": "Сурхондарйо вилояти",
    "sirdarya": "Сирдарйо вилояти",
    "tashkent": "Тошкент",
    "namangan": "Наманган вилояти",
    "fergana": "Фаргона вилояти",
    "andijan": "Андижон вилояти"
  },
  "admin": {
    "admin": "Админ",
    "profile": "Паролни тахрирлаш",
    "changepassword": "Паролни озгартириш",
    "changed_profile": "Муваффакийатли озгариш",
    "return": "Кайтиш",
    "username": "Исм",
    "surname": "Фамилия",
    "userlogin": "Кириш",
    "usermail": "Электрон почта",
    "userbio": "Узим хакимда",
    "infbio": "Узингиз хакингизда малумот кошинг",
    "maxwords": "* Максимал 150 та белгидан иборат",
    "apply": "Коллаш",
    "currentpassword": "Эски паролингизни киритинг",
    "userpassword": "Йанги паролни киритинг",
    "replypassword": "Йанги паролни такрорланг",
    "length": "Парол камида саккизта ракам, харф ва тиниш белгилардан иборат болиши керак",
    "video": "Ушбу катор толдирилми шарт",
    "repeatable_fields": " Мундарижа ва пастки категория мавжуд",
    "title": "Йангилик йаратиш",
    "changeLang": "* Йангиликни узбек тилида чоп етиш учун уни ичига йозиш керак иккита версия - лотин ва кирил алифболарида",
    "prevLang": "Йангиликни",
    "lang": "тилда йаратиш",
    "latinlang": "Майдонларни ",
    "latinlangOne": "толдиринг",
    "latin": "лотинда",
    "kr": "Кирилда",
    "comment": "Куйидаги хатоларни тузатинг",
    "contentTitle": "Мундарижа:",
    "brief": "Кискача:",
    "description": "Тавсифи",
    "media": "Видео материал:",
    "image": "Чизма:",
    "atMoment": "Хозирги пайтда:",
    "selectFile": "Файлни танланг",
    "delete": "Очириш",
    "tags": "Теглар:",
    "avialable": "Мавжуд теглар",
    "selected": "Танланган теглар",
    "country": "Мамалакатни танланг",
    "regions": "Вилоятни танланг",
    "selectedRegions": "Танланган вилоят",
    "selectedCountry": "Танланган мамлакат",
    "regions_selected": "Камида битта вилоят тегини танланг",
    "country_selected": "Камида битта мамлакат тегини танланг",
    "search": "Кидирмок",
    "filter": "Филтр",
    "commandControl": "Бир нечта кийматларни танлаш учун Control (йоки Mac-даги буйрук) тугмасини босиб туринг.",
    "selectAll": "Хаммасини танланг",
    "removeAll": "Хаммасини очириш",
    "newsCategory": "Йангиликлар тоифаси:",
    "status": "Йангиликлар холати:",
    "draft": "Коралама",
    "date": "Нашр килинган сана:",
    "explanationDate": "Йангилик елон килинадиган сана ва вакт",
    "editing": "Сакланг ва тахирлашни давом етинг",
    "save": "Сакланг",
    "addedNews": "Йангилик кошилди",
    "views": "Умумий корганлар сони",
    "add_news": "Йангилик кошинг",
    "go_out": "Сайтдан чикиш",
    "home": "Йангиликларга",
    "changeIMage": "Расмни озгартириш",
    "published_news": "Э'лон килинган йангиликлар",
    "moderation": "Модератсия кутилмокда",
    "rejected": "Рад етилган йангиликлар",
    "drafts": "Кораламалар",
    "redactor": "Тахрирлаш",
    "Go_to": " Йангиликга отиш",
    "change_language": "Тилни озгартириш",
    "in_en": "Инглиз тилида",
    "in_ru": "Рус тилида",
    "in_uz": "Узбек тилида",
    "choose_lang": "Кайси тилда йангиликлар киритишингиз танланг",
    "success_msg": "Йангилик модератсияга мувоффакиятли юборилди",
    "not_published": "Сизда танланган тилда нашр этилган йангилик йок",
    "mediaToTg": "Телеграмдаги медиа",
    "msgToTg": "Телеграмдаги хабар",
    "videoToTg": "Телеграмдаги видео"
  },
  "super_user": {
    "title": "Озгартириш учун йангиликларни танланг",
    "set_page": "га боригнг",
    "news_count": "Йангиликлар",
    "search": "топинг",
    "filter": "Филтр",
    "id": "ID",
    "news_title": "МУНДАРИЖА",
    "news_author": "ЙАНГИЛИКЛАР МУАЛЛИФИ",
    "news_category": "ЙАНГИЛИКЛАР КАТЕГОРИЯСИ",
    "news_date": "НАШР ЕТИЛГАН САНА",
    "news_status": "ЙАНГИЛИКЛАР СТАТУСИ",
    "draft": "КОРАЛАМА",
    "move": "корсатилган",
    "from": "дан",
    "clear": "барча филтрларни тозаланг",
    "from_date": "санасидан бошлаб",
    "to_date": "Сана бойича",
    "reset": "кайта орнатиш",
    "all": "Хаммаси",
    "yes": "Ха",
    "no": "Йок"
  }
}